import React, { PureComponent } from 'react'
import DownIcon from 'mdi-react/ChevronDownIcon'
import TopbarMenuLink from './TopbarMenuLink'
import { DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown } from 'reactstrap'
import Gravatar from 'react-gravatar'
import { DASHBOARD_PATH, LOGOUT_PATH } from '../../utils/constants'

export default class TopbarProfile extends PureComponent {
  render() {
	  const { email, name } = this.props;
    return (
      <UncontrolledDropdown className='topbar__profile'>
        <DropdownToggle className='topbar__avatar'>
          <Gravatar className='topbar__avatar-img' email={email} alt='avatar' />
          <p className='topbar__avatar-name'>{name}</p>
          <DownIcon className='topbar__avatar-icon' />
        </DropdownToggle>
        <DropdownMenu className='topbar__menu dropdown__menu'>
          <DropdownItem>
            <TopbarMenuLink title='Dashboard' icon='home' path={DASHBOARD_PATH} />
          </DropdownItem>
          <DropdownItem divider className='topbar__menu-divider' />
          <DropdownItem>
            <TopbarMenuLink title='Log Out' icon='exit' path={LOGOUT_PATH} />
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/topbar/TopbarProfile.js